var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 842.95 249.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.95;fill:url(#linear-gradient);}.cls-2{opacity:0.89;fill:url(#linear-gradient-2);}.cls-3{opacity:0.94;fill:url(#linear-gradient-3);}.cls-4{fill:#ed1c24;stroke:#ed1c24;}.cls-4,.cls-5,.cls-6{stroke-miterlimit:10;stroke-width:3.5px;}.cls-5{fill:#293876;stroke:#293876;}.cls-6{fill:#fff200;stroke:#fff200;}.cls-7{font-size:24px;fill:#414042;font-family:SackersGothicStd-Medium, Sackers Gothic Std;font-weight:500;letter-spacing:0.2em;}.cls-8{opacity:0.82;}.cls-9{fill:#231f20;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -306.19,
    y1: 890.13,
    x2: -194.05,
    y2: 708.36,
    gradientTransform: "translate(141.02 -774.78) rotate(-13.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#293876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#324590",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#30438b",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2b3b7d",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293876",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -230.23,
    y1: 776.55,
    x2: -148.87,
    y2: 931.83,
    gradientTransform: "translate(141.02 -774.78) rotate(-13.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fed700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fed700",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fed700",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fed700",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fed700",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fed700",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fed800",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fedb00",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fee000",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ffe700",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fff100",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fff200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -317.3,
    y1: 891.29,
    x2: -106.53,
    y2: 938.97,
    gradientTransform: "translate(141.02 -774.78) rotate(-13.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#be1e2d",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#be1e2d",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#bd1f2e",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#bd202e",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#bd202e",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#bd202e",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#bd1f2e",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#be1e2d",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#be1e2d",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#be1e2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "106.05 215.06 106.52 125.26 23.8 78.66 134.51 14.11 109.22 0 0.56 64.68 0.55 64.68 0.95 126.58 0 155.52 0.24 155.1 106.05 215.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "217.95 60.12 162.78 29.57 162.78 29.58 138.68 16.14 31.55 78.6 109.97 122.77 193.86 72.35 194.32 199.13 217.95 184.9 217.95 60.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "190.03 79.15 110.34 127.05 109.99 194.71 110.15 219.54 110.16 221.78 109.85 221.62 0.76 159.81 0.95 189.23 109.72 249.88 164.05 217.55 164.06 217.54 190.47 201.82 190.03 79.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 466.95,
    y1: 151,
    x2: 611.95,
    y2: 151
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 321.95,
    y1: 151,
    x2: 466.95,
    y2: 151
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 611.95,
    y1: 151,
    x2: 756.95,
    y2: 151
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(373.25 185.81)"
  }, "PRIVATE LIMITED"), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M266.51,137.89c-16.9,0-30.57-15.79-30.57-39.94,0-23.55,13-40.06,29.69-40.06,10.14,0,19.4,5.2,26.53,15.19l-4.63,6.22c-6.32-7.75-13.37-12.54-22.27-12.54-12.49,0-22.85,13.45-22.85,31,0,19.26,11.24,31.19,24.47,31.19,8.82,0,15.58-4.28,21.68-13.05l4.41,6.83C285.25,133.31,277.68,137.89,266.51,137.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M337.63,134l-5-12h-23.9l-4.84,12H297L317.6,84h6.48l20.76,50ZM320.77,93.49,312.39,114h16.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M387.74,112.22c-3.16,3.59-5,3.78-12,3.78H361v18h-7V84h23.91c4.9,0,6,.49,8.22,2.23,3.7,2.82,5.59,8.63,5.59,14C391.67,104.76,390.46,109.12,387.74,112.22ZM376.94,92H361v15h15.23c7.05,0,9.32-1.16,9.32-7.3S382.85,92,376.94,92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M436.56,134l-4.94-12H408l-4.79,12h-6.83l20.38-50h6.41l20.52,50ZM419.88,93.49,411.59,114h16.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M474.35,135.6c-11.7,0-19.41-4.6-27.55-16.1l4.58-6.2c7.12,9.7,12.79,13.4,22.9,13.4,6.69,0,19.33-2.7,19.33-15,0-9-6.76-12.6-12.28-12.7l-11.49-.2c-6.83-.1-10.17-1.2-13.44-4.1-3.57-3.2-5.6-9-5.6-14.8,0-16.5,13.52-22.5,23.4-22.5,8.87,0,15.92,3.6,23,11l-4,6.9c-6.25-6.1-11.49-9-19.19-9-5.82,0-16.72,3.2-16.72,13.6,0,3.1,1.23,6.2,3.2,7.7,2.47,1.8,4.14,2.3,11,2.4l8.06.1a21.9,21.9,0,0,1,11.13,2.5c5.59,3.2,9.37,11.1,9.37,19.4C500.08,130.11,485,135.6,474.35,135.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M529,92v42h-7V92H508V84h37v8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M589.42,135l-11.54-21H564v21h-7V84h25.17c8.26,0,15.5,3.25,15.5,15.07,0,8.66-4.25,13.78-10.94,14.86L598.56,135ZM582.2,92H564v13h18.64c3.81,0,7.77-1,7.77-6.9C590.36,93.7,588.73,92,582.2,92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M609,135V84h33v8H615v12h15v9H615v13h28v9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M689.33,134,665,96.84V134h-7V84h6.7L689,121.07V84h7v50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M732.26,135.8c-12.66,0-24.38-9.63-24.38-25.87,0-16.71,12.12-25.77,24.93-25.77,7.4,0,13.22,2.64,19,8l-4,6.7c-5.59-4.72-8.73-6.42-15.58-6.42-8.65,0-17.38,6.05-17.38,17.47s8.81,17.56,17.46,17.56c6,0,8.5-1,13.61-4.72V115H735v-8h18v20.11C746.42,132.78,740.52,135.8,732.26,135.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M781,92v42h-7V92H760V84h36v8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M836,134V113H813v21h-7V84h6v20h24V84h7v50Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.6f7ae6a53c970b9e0ec2754212f06f60.svg";
export { ForwardRef as ReactComponent };